export const SET_CURRENT_CURRENCY = 'currencies/SET_CURRENT_CURRENCY';
export const SET_CURRENCIES = 'currencies/SET_CURRENCIES';
